module.exports = __webpack_public_path__ + "media/landing_page/personal_path-b9f12860.webp";